import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Form } from 'foundations-components/transitional/components/Form';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { useContext, useEffect, useState } from 'react';
import { toObjectTypes } from '../../constants/types';
import { AppContext, appActions } from '../../contexts/app/context';
import { AssociationModalPropsContext } from '../../contexts/associationModal/PropsContext';
import { AssociationModalContext } from '../../contexts/associationModal/context';
import FooterButtons from './FooterButtons';
import AssociationModalTabs from './Tabs/AssociationModalTabs';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationModalBody({
  associateCrmObjectComponent,
  isLoading,
  onClose,
  onSelectedTabChange,
  isSubmittingFailed,
  getOnSubmitAction,
  isSubmitButtonEnabled,
  selectedTab
}) {
  const {
    isContactsPage,
    crmObjectType,
    showModal
  } = useContext(AssociationModalPropsContext);
  const {
    appName
  } = useContext(AppContext);
  const {
    associationModalActions
  } = useContext(AssociationModalContext);
  const [isApiOutageError, setIsApiOutageError] = useState(false);
  useEffect(() => {
    appActions.setSkipIntervalRefresh(true);
    return () => {
      appActions.setSkipIntervalRefresh(false);
    };
  }, []);
  useEffect(() => {
    if (crmObjectType === toObjectTypes.deal && showModal) {
      associationModalActions.getCurrencies();
      associationModalActions.getDealAmountSettings();
    }
  }, [crmObjectType, showModal, associationModalActions]);
  return /*#__PURE__*/_jsxs(ModalPanel, {
    "data-test-id": `${appName}-association-modal-panel`,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "associationsPanel.title",
          options: {
            objectType: crmObjectType
          }
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      padding: "300",
      children: [isContactsPage && associateCrmObjectComponent ? /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "800",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "associationsPanel.description"
        })
      }) : null, /*#__PURE__*/_jsx(Form, {
        children: /*#__PURE__*/_jsx(AssociationModalTabs, {
          onSelectedTabChange: onSelectedTabChange,
          associateCrmObjectComponent: associateCrmObjectComponent,
          isApiOutageError: isApiOutageError,
          setIsApiOutageError: setIsApiOutageError
        })
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      padding: "300",
      children: /*#__PURE__*/_jsx(FooterButtons, {
        isLoading: isLoading,
        isFailed: isSubmittingFailed,
        onSubmit: getOnSubmitAction,
        saveButtonEnabled: !!isSubmitButtonEnabled && !isApiOutageError,
        buttonMessage: `associationsPanel.tabs.${selectedTab}.submitButton`,
        onCancel: onClose,
        crmObjectType: crmObjectType,
        appName: appName
      })
    })]
  });
}
export default AssociationModalBody;